// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import { BrowserRouter } from 'react-router-dom';
// import { UserProvider } from './UserContext'; // Import the UserProvider
// import { NotificationProvider } from './Components/NotificationSetup'; // Import the NotificationProvider

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <UserProvider>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </UserProvider>
// );

// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './UserContext';
import { NotificationProvider } from './Components/NotificationSetup';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <UserProvider>
    <NotificationProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </NotificationProvider>
  </UserProvider>
);
